import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import '../../Styles/contact.css'



function Contact() {
/*   const frmContact = { 
    formName:'', 
    formEmail:'', 
    formMsg:'' 
  };
  const [contact,setContact] = useState(frmContact);
  const [validated, setValidated] = useState(false);
  const handleChange = e => { 
		const {name,value} = e.target;
		setContact({...contact,[name]:value}); 
    
   };

  const handleSubmit = (event) => {
    
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }else{
      event.target.reset()
      alert('Su mensaje fue enviado');
      emailjs.sendForm('service_f7rashh', 'template_frzdndw', event.target, 'user_DT4c1MjXH0lIe5ccKcC6h')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      
      
    }
    setValidated(true);
  }; */

  return (
      <div className="container o-contact">
        <div className="o-row-contact">
          <div className=" o-title-cont">
            <i className="fas fa-book-reader o-icon-cont"></i>
            <h1 className="o-cont-title">Let’s build systems that drive growth</h1>
            <p className="o-cont-subtitle">
              If you’re looking for someone who combines frontend development,
              systems thinking, and growth-focused implementation, I’d love to
              connect.
            </p>
          </div>

          <Form  action="https://api.web3forms.com/submit" method="POST">
            <Row>
              <Form.Group as={Col} md="12" controlId="validationCustom01">
              <p className='o-p-contact'>Full Name</p>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter your name"
                  name="Name:"

                />
                <Form.Control.Feedback type="invalid">
              Enter a name
            </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-1">
              <Form.Group as={Col} md="12" controlId="validationCustomEmail">
              <p className='o-p-contact'>Email Address</p>
                <Form.Control
                  required
                  type="email"
                  placeholder="Enter your email"
                  name="Email:"
                />
               <Form.Control.Feedback type="invalid">
              Enter a valid email
            </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="12" controlId="validationCustom02" >
                <p className='o-p-contact'>Your Message</p>
                <textarea 
                className="form-control" 
                id="exampleFormControlTextarea1" 
                placeholder="Enter your message" 
                rows="10"
                required
                type="text"
                name="Message:"
                ></textarea>
                <Form.Control.Feedback type="invalid">
              Enter a message
            </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <input type="hidden" name="redirect" value="https://web3forms.com/success"></input>
            <input type="hidden" name="apikey" value="65eeee48-e1ad-4c8c-9282-fe24236071ca"></input>
            <p className="o-cont-helper">
              Let’s talk about websites, systems, automation, or
              conversion-focused experiences.
            </p>
            <Row>
              <button type="submit" className="btn-contact o-btn-cont">Send message</button>
            </Row>
          </Form>
        </div>
      </div>
  );
}


export default Contact;